<template>
  <v-row dense no-gutters>
    <v-col cols="8">
      <grade-properties-table :grade="grade" :value="currentProperty" :decorateNumerals="true" @input="onPropertyChanged"/>
    </v-col>
    <v-col cols="4">
      <grade-property-card :property="currentProperty.length ? currentProperty[0] : {}" :mode="'viewer'" :full-view="true"/>
    </v-col>
    <ref-add-grade-property-dialog
      :property="currentProperty.length ? currentProperty[0] : {}"
      :grade="grade"
      v-model="showAddProperty"
      @propertyAdded="onAddProp"
      @propertyUpdate="onUpdateProp"/>
    <sys-confirm-dialog :value="dlgShowConfirm" :message="'Подтвердите удаление'" :no-call-back="cancelConfirmDialog" :ok-call-back="doDeleteGradeProp"/>
  </v-row>
</template>

<script>

import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'
import GradePropertiesTable from '@/components/modules/references/tables/gradePropertiesTable'
import GradePropertyCard from '@/components/modules/references/cards/gradePropertyCard'
import RefAddGradePropertyDialog from '@/components/modules/references/dialogs/refAddGradePropertyDialog'

export default {
  name: 'gradePropertiesCard',
  components: { RefAddGradePropertyDialog, GradePropertyCard, GradePropertiesTable, SysConfirmDialog },
  props: {
    grade: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      addProperty: { text: 'Добавить свойство', actionType: 'Свойства', action: 'addRcptProp', method: this.addRcptProperty, icon: 'mdi-plus', params: '' },
      editProperty: { text: 'Изменить свойство', actionType: 'Свойства', action: 'updRcptProp', method: this.updRcptProperty, icon: 'mdi-pencil', params: '' },
      delProperty: { text: 'Удалить свойство', actionType: 'Свойства', action: 'delRcptProp', method: this.delRcptProperty, icon: 'mdi-close', params: '' },
      currentProperty: [],
      dlgShowConfirm: false,
      showAddProperty: false
    }
  },
  watch: {
    grade (val) {
      console.log('gradePropertiesCard grade changed to ', val)
      this.setActions()
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, {
        actionType: 'Свойства',
        actions: []
      })
      if (this.grade.GRADE_ID) {
        this.$store.dispatch(UI_ADD_ACTION, this.addProperty)
      }
      if (this.currentProperty.length > 0) {
        this.$store.dispatch(UI_ADD_ACTION, this.editProperty)
        this.$store.dispatch(UI_ADD_ACTION, this.delProperty)
      }
    },
    addRcptProperty () {
      this.currentProperty.splice(0, 1)
      this.showAddProperty = true
    },
    updRcptProperty () {
      console.log('gradePropertiesCard calling updRcptProperty with active property ', this.currentProperty)
      this.showAddProperty = true
    },
    onPropertyChanged (val) {
      console.log('gradePropertiesCard onPropertyChanged called with val ', val)
      this.currentProperty.splice(0, 1, ...val)
      this.setActions()
    },
    onAddProp (val) {
      this.$emit('onChange', {})
      this.onPropertyChanged(val)
      this.showAddProperty = false
    },
    onUpdateProp (val) {
      this.onPropertyChanged(val)
      this.showAddProperty = false
    },
    delRcptProperty () {
      console.log('Calling for confirm dialog')
      this.dlgShowConfirm = true
    },
    cancelConfirmDialog () {
      this.dlgShowConfirm = false
    },
    doDeleteGradeProp () {
      console.log('Closing confirm dialog')
      this.dlgShowConfirm = false
      const processorPath = '/api/org/references/delGradeProperty.php'
      const payload = {
        PROP_PKUUID: this.currentProperty[0].PROP_PKUUID
      }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            this.currentProperty.splice(0, 1, { action: 'delete', PROP_PKUUID: this.currentProperty[0].PROP_PKUUID })
            this.$emit('onChange', {})
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    }
  },
  mounted () {
    this.setActions()
  }
}
</script>
